import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../core/store/store';
import Navbar from '../../../shared/components/Navbar';
import BackgroundImage from '../../../shared/components/BackgroundImage';
import ParticlesBackground from '../../../shared/components/ParticlesBackground';
import RoleDefaultAccessContent from './components/RoleDefaultAccessContent';

const RoleDefaultAccessManagement: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();

  const hasAccess = currentUser?.roles_id && currentUser.roles_id <= 2;

  useEffect(() => {
    if (!hasAccess) {
      navigate('/panel');
    }
  }, [hasAccess, navigate]);

  if (!hasAccess) {
    return null;
  }

  return (
    <div className="min-h-screen relative overflow-hidden">
      <BackgroundImage />
      <ParticlesBackground />
      <Navbar />
      <div className="relative z-10 pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex items-center justify-between">
            <div>
              <h1 className="text-5xl font-bold text-white mb-2 text-gradient">
                Gestion des accès par défaut des rôles
              </h1>
              <p className="text-gray-300">
                Définissez les accès par défaut pour chaque rôle. Les joueurs hériteront automatiquement de ces accès.
              </p>
            </div>
            <button
              onClick={() => navigate('/panel')}
              className="px-6 py-3 bg-gradient-to-r from-primary-600 to-purple-600 text-white rounded-lg font-semibold hover:from-primary-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span>Retour au panel</span>
            </button>
          </div>
          <RoleDefaultAccessContent />
        </div>
      </div>
    </div>
  );
};

export default RoleDefaultAccessManagement;

